import { useGetCalculationQuery } from '../apiCalculationDetail';
import { canEditCalculation } from './editRedistributionLib';
import { CalculationType, ValidationProblemCode } from '@ydistri/api-sdk';
import { messageFor } from '../../Configuration/Validator/problemsLib';
import { useUser } from '../../../hooks/useUser';

export interface CalculationEditResult {
  isBackedUp: boolean;
  isProduction: boolean;
  isSubmerged: boolean;
  isSkuRedistributionEdited: boolean;
  isSuperUser: boolean;
  canEdit: boolean;
  isFetching: boolean;
  disabledTooltipMessage?: string;
  disabledRestoreTooltipMessage?: string;
}

export const useCalculationEdit = (calculationId: number): CalculationEditResult => {
  const { isFetching, isBackedUp, type, isSkuRedistributionEdited, canEdit } =
    useGetCalculationQuery(calculationId, {
      selectFromResult: ({ data, isFetching }) => {
        const type = data?.type;
        const isBackedUp = data?.isBackedUp ?? false;
        const isSkuRedistributionEdited = data?.isSkuRedistributionEdited ?? false;

        return {
          isFetching,
          type,
          isBackedUp,
          isSkuRedistributionEdited,
          canEdit: canEditCalculation(data),
        };
      },
    });

  const isSuperUser = useUser()?.isSuperUser ?? false;

  let disabledTooltipMessage = undefined;
  let disabledRestoreTooltipMessage = undefined;

  if (type === CalculationType.Production) {
    disabledTooltipMessage = 'Production calculations cannot be edited.';
    disabledRestoreTooltipMessage = 'Production calculations cannot be restored.';
  } else if (type === CalculationType.Submerged) {
    disabledTooltipMessage = messageFor(ValidationProblemCode.CalculationSubmergedNotEditable);
    disabledRestoreTooltipMessage = disabledTooltipMessage;
  }

  return {
    isBackedUp,
    isProduction: type === CalculationType.Production,
    isSubmerged: type === CalculationType.Submerged,
    isSkuRedistributionEdited,
    isSuperUser,
    canEdit,
    isFetching,
    disabledTooltipMessage,
    disabledRestoreTooltipMessage,
  };
};
